









































































































































import { Component, Vue } from 'vue-property-decorator';
import restService from '../services/rest.service';
import moment from 'moment';
import wizardService from '../services/wizard.service';
import Card from '@/components/Card.vue';

@Component({
  components: {
    Card,
  },
})
export default class Home extends Vue {

  public async mounted() {
    this.$data.account = await wizardService.getMe();
    this.$data.card = await restService.card('eternity-gift');
  }

  public data() {
    const randLimit: number = .85;
    return {
      account: null,
      card: null,
      eternityMessageHidden: window.localStorage.getItem('eternityMessageHidden') === 'true' ? true : false,
      fragments: [
        {id: 'CCXXXV', obtened: Math.random() > randLimit},
        {id: 'CCXXXI', obtened: Math.random() > randLimit},
        {id: 'CCXXVII', obtened: Math.random() > randLimit},
        {id: 'CCXXIII', obtened: Math.random() > randLimit},
        {id: 'CCXIX', obtened: Math.random() > randLimit},
        {id: 'CCXV', obtened: Math.random() > randLimit},
        {id: 'CCXI', obtened: Math.random() > randLimit},
        {id: 'CCVII', obtened: Math.random() > randLimit},
        {id: 'CCIII', obtened: Math.random() > randLimit},
        {id: 'CXCIX', obtened: Math.random() > randLimit},
        {id: 'CXCV', obtened: Math.random() > randLimit},
        {id: 'CXCI', obtened: Math.random() > randLimit},
        {id: 'CLXXXVII', obtened: Math.random() > randLimit},
        {id: 'CLXXXIII', obtened: Math.random() > randLimit},
        {id: 'CLXXIX', obtened: Math.random() > randLimit},
        {id: 'CLXXV', obtened: Math.random() > randLimit},
        {id: 'CLXXI', obtened: Math.random() > randLimit},
        {id: 'CLXVII', obtened: Math.random() > randLimit},
        {id: 'CLXIII', obtened: Math.random() > randLimit},
        {id: 'CLIX', obtened: Math.random() > randLimit},
        {id: 'CLV', obtened: Math.random() > randLimit},
        {id: 'CLI', obtened: Math.random() > randLimit},
        {id: 'CXLVII', obtened: Math.random() > randLimit},
        {id: 'CXLIII', obtened: Math.random() > randLimit},
        {id: 'CXXXIX', obtened: Math.random() > randLimit},
        {id: 'CXXXIII', obtened: Math.random() > randLimit},
        {id: 'CXXVIII', obtened: Math.random() > randLimit},
        {id: 'CXXIV', obtened: Math.random() > randLimit},
        {id: 'CXX', obtened: Math.random() > randLimit},
        {id: 'CXVI', obtened: Math.random() > randLimit},
        {id: 'CXII', obtened: Math.random() > randLimit},
        {id: 'CIV', obtened: Math.random() > randLimit},
        {id: 'C', obtened: Math.random() > randLimit},
        {id: 'XCVI', obtened: Math.random() > randLimit},
        {id: 'XCIII', obtened: Math.random() > randLimit},
        {id: 'XC', obtened: Math.random() > randLimit},
        {id: 'LXXXV', obtened: Math.random() > randLimit},
        {id: 'LXXXI', obtened: Math.random() > randLimit},
        {id: 'LXXVI', obtened: Math.random() > randLimit},
        {id: 'LXV', obtened: Math.random() > randLimit},
        {id: 'LXII', obtened: Math.random() > randLimit},
        {id: 'XLVII', obtened: Math.random() > randLimit},
        {id: 'XXXIX', obtened: Math.random() > randLimit},
        {id: 'XXXIII', obtened: Math.random() > randLimit},
        {id: 'XXVI', obtened: Math.random() > randLimit},
      ],
      users: [
        {id: 0, name: 'Test 1', count: 7},
        {id: 0, name: 'Test 2', count: 6},
        {id: 0, name: 'Test 3', count: 5},
        {id: 0, name: 'Test 4', count: 4},
        {id: 0, name: 'Test 5', count: 3},
        {id: 0, name: 'Test 6', count: 2},
        {id: 0, name: 'Test 7', count: 1},
      ],
    };
  }

  public get fragmentsObtened(): number {
    return this.$data.fragments.filter((f: any) => f.obtened).length;
  }

  public hasObtened(id: string): boolean {
    const find = this.$data.fragments.find((f: any) => f.id === id);
    return find && find.obtened;
  }

  public hideEternityMessage() {
    this.$data.eternityMessageHidden = true;
    window.localStorage.setItem('eternityMessageHidden', 'true');
  }

}
